import { useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";
import { allowedTabs } from "../constants/permissionCatalog";
import AllSquads from "../pages/dashboardPage/squadSettings/allSquads/AllSquads";
import SquadImages from "../pages/dashboardPage/squadSettings/squadImages/SquadImages";

// Tab id (permissionCatalog "squads") → its page.
const TAB_PAGES = {
  "all-squads": AllSquads,
  "squad-images": SquadImages,
};

const SquadNavigator = () => {
  const { rolePermissions } = useSelector((state) => state.user);
  const tabs = allowedTabs("squads", rolePermissions);
  const FirstTab = tabs[0] ? TAB_PAGES[tabs[0].id] : null;

  return (
    <Routes>
      {tabs.map((tab) => {
        const Page = TAB_PAGES[tab.id];
        return <Route key={tab.id} path={`/${tab.path}`} element={<Page />} />;
      })}
      {FirstTab && <Route path="*" element={<FirstTab />} />}
    </Routes>
  );
};

export default SquadNavigator;
